/* =================== BLOG HOME =================== */
$(function () {
    $(".carrosel-sobre-home").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 2000,
      arrows: true,
    });
  });
  